export default {
  name: "UserSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 26.95c0 1.21-.84 2.05-2 2.05H6a2 2 0 0 1-2-2v-.05c.39-7.17 4.69-10.04 8.03-11.18A7.01 7.01 0 0 1 16 3a7 7 0 0 1 3.96 12.76c3.35 1.15 7.65 4.01 8.04 11.19z",
  },
}
